import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { Catalogue } from '../../models/catalogue'
import { CatalogueState, catalogueStoreKey } from './catalogue.state'

const getCatalogues = (state: CatalogueState): Catalogue[] => state.catalogues

export const selectCatalogueState: MemoizedSelector<object, CatalogueState> =
  createFeatureSelector<CatalogueState>(catalogueStoreKey)
export const selectCatalogues: MemoizedSelector<object, Catalogue[]> = createSelector(
  selectCatalogueState,
  getCatalogues
)
